module.exports = __webpack_public_path__ + "neutral_face.svg?d5757902eb64b826cd0789606dc04529";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/feelings2/neutral_face.svg
// module id = 89
// module chunks = 0